import { ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ContainerProps {
  as?: ElementType;
  className?: string;
  children: ReactNode;
  /** Widen for full-bleed sections while keeping padding. */
  size?: "default" | "wide" | "narrow";
}

const sizes: Record<NonNullable<ContainerProps["size"]>, string> = {
  narrow: "max-w-3xl",
  default: "max-w-[1240px]",
  wide: "max-w-[1440px]",
};

/** Horizontal centering + responsive gutters. Used by every section. */
export function Container({
  as: Tag = "div",
  className,
  children,
  size = "default",
}: ContainerProps) {
  return (
    <Tag
      className={cn(
        "mx-auto w-full px-5 sm:px-8 lg:px-12",
        sizes[size],
        className,
      )}
    >
      {children}
    </Tag>
  );
}
